export const SUPPORTED_COLLTECION_CONSTS = {
  SENTINEL: 'sentinel-2-l2a',
  D2: 'pixxel-td1-l2a',
  SHAKUNTALLA: 'pixxel-td2-l2a',
  MODIS_NBAR_DAILY: 'modis-43A4-061',
  PIXXEL_FIREFLY: 'pixxel-ff-l2a'
};

export const CONSTELLATION_IDS_CONSTS = {
  SENTINEL_2: '0002a3a3-00a2-4b55-842b-44d8202c6d60',
  PIXXEL_D2: '0004ab8d-0ad1-4d62-8a3f-fe18a7000e70',
  SHAKUNTALA: '0005c5bb-0bd2-4c80-9393-4a808341c54c',
  MODIS_NBAR_DAILY: '0003b6a9-e6eb-407d-ad16-a8ab65009f9f',
  LANDSAT_8_9: '0001fda9-1a89-4c15-be08-4eed1e8c993b',
  SENTINEL_1_RTC: '0006ef9c-fb90-4de6-8256-35ef885ed784',
  MODIS_LSTE_8_DAY: '0007bc9a-fe55-4fb6-b5eb-0be19c653b55',
  MODIS_SURFACE_REFLECTANCE_8_DAY: '0008c6d7-531d-467e-a1d5-5d8c5a5cd512',
  EO_01_HYPERION: '0009cd8f-1a91-4fb0-b82c-0808b047640f',
  PIXXEL_FIREFLY: '1d60daec-b29a-47af-9161-1db476ed2506'
};

export const CONSTELLATION_CONTROL = [
  CONSTELLATION_IDS_CONSTS.SENTINEL_2,
  CONSTELLATION_IDS_CONSTS.PIXXEL_D2,
  CONSTELLATION_IDS_CONSTS.SHAKUNTALA,
  CONSTELLATION_IDS_CONSTS.PIXXEL_FIREFLY
];

export const COLLECTION_MAP = {
  [CONSTELLATION_IDS_CONSTS.SENTINEL_2]: SUPPORTED_COLLTECION_CONSTS.SENTINEL,
  [CONSTELLATION_IDS_CONSTS.PIXXEL_D2]: SUPPORTED_COLLTECION_CONSTS.D2,
  [CONSTELLATION_IDS_CONSTS.SHAKUNTALA]:
    SUPPORTED_COLLTECION_CONSTS.SHAKUNTALLA,
  [CONSTELLATION_IDS_CONSTS.PIXXEL_FIREFLY]:
    SUPPORTED_COLLTECION_CONSTS.PIXXEL_FIREFLY
};

export const SENTINEL_2_FILTER_DATA = {
  provider: 'planetary',
  queryables: ['eo:cloud_cover', 'gsd'],
  eo_bands: [
    'B01',
    'B02',
    'B03',
    'B04',
    'B05',
    'B06',
    'B07',
    'B08',
    'B09',
    'B11',
    'B12',
    'B8A',
    'SCL'
  ],
  collection_id: SUPPORTED_COLLTECION_CONSTS.SENTINEL
};

export const UTM_CONSTELLATIONS = new Set(
  SUPPORTED_COLLTECION_CONSTS.D2,
  SUPPORTED_COLLTECION_CONSTS.SHAKUNTALLA,
  SUPPORTED_COLLTECION_CONSTS.PIXXEL_FIREFLY
);
